import { UserOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, Flex, Image, Layout } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';

import LogoIcon from '../images/logo-icon.png';
import { logoutUser, selectUser } from '../store/reducers/sessionReducer';
import useScreenSize from '../utils/useScreenSize';
import './mainlayout.css';
import Clock from '../components/Clock';

const { Header, Content } = Layout;

const WorkshopLayout = () => {
    const { isMobile, isTabletToMobile } = useScreenSize();
    const user = useSelector(selectUser);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogout = async () => {
        const session = localStorage.getItem('session') || sessionStorage.getItem('session');
        console.log(session);
        const isWorkshop = session?.startsWith('workshop') || false;
        const redirectTo = isWorkshop ? '/service' : '/login';
        await dispatch(logoutUser()).unwrap();
        console.log(redirectTo);
        navigate(redirectTo);
    };

    const userMenuItems = [
        { key: '1', label: 'Profile' },
        { key: '2', label: 'Logout', onClick: handleLogout }
    ];

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Layout>
                <Header
                    style={{
                        background: '#3b8eb9',
                        padding: isTabletToMobile ? '0' : '0 20px',
                        display: 'flex',
                        justifyContent: isTabletToMobile ? '' : 'space-between',
                        alignItems: 'center',
                        height: '51px',
                        lineHeight: 'inherit'
                    }}>
                    {isTabletToMobile ? (
                        <Flex
                            align="center"
                            justify="center"
                            style={{
                                padding: '5px 10px',
                                backgroundColor: '#3382b0',
                                textAlign: 'center',
                                minHeight: '51px',
                                marginRight: 6
                            }}>
                            <Image src={LogoIcon} preview={false} style={{ height: '32px', objectFit: 'contain' }} />
                        </Flex>
                    ) : (
                        ''
                    )}
                    <Flex align="center" justify="center" style={{ color: 'white' }}>
                        Workshop
                    </Flex>
                    <Flex
                        gap={14}
                        align="center"
                        style={{
                            paddingRight: isTabletToMobile ? '15px' : '',
                            marginLeft: isTabletToMobile ? 'auto' : ''
                        }}>
                        {!isMobile && <Clock />}

                        <Dropdown
                            menu={{ items: userMenuItems }}
                            placement="bottomRight"
                            trigger={['click']}
                            dropdownRender={(menu) => (
                                <div
                                    style={{
                                        width: '150px',
                                        position: 'relative',
                                        top: 0
                                    }}>
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '-8px',
                                            right: '8px',
                                            width: 0,
                                            height: 0,
                                            borderLeft: '8px solid transparent',
                                            borderRight: '8px solid transparent',
                                            borderBottom: '8px solid white', // Match dropdown background
                                            zIndex: 1
                                        }}
                                    />
                                    {menu}
                                </div>
                            )}>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    cursor: 'pointer'
                                }}>
                                <Avatar icon={<UserOutlined />} />
                                <span style={{ color: 'white' }}>{user?.name}</span>
                                <span style={{ color: 'white' }}>{user?.role}</span>
                            </div>
                        </Dropdown>
                    </Flex>
                </Header>
                <Content className="mainlayout" style={{ backgroundColor: '#ffffff' }}>
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
};

export default WorkshopLayout;
